import React from 'react';
import { useProgressiveImage } from './useProgressiveImage';

interface ProgressiveImageProps {
    lowQualitySrc: string;
    highQualitySrc: string;
    alt: string;
    className?: string;
    onClick?: () => void;
    width?: number;
    height?: number;
}

/**
 * Progressive Image Component
 * Displays low-quality image immediately, then smoothly transitions to high-quality
 */
export const ProgressiveImage: React.FC<ProgressiveImageProps> = ({
    lowQualitySrc,
    highQualitySrc,
    className = '',
    onClick,
    width,
    height,
}) => {
    const { src } = useProgressiveImage(lowQualitySrc, highQualitySrc);

    return (
        <img
            src={src}
            alt={'(?) image missing...'}
            className={className}
            onClick={onClick}
            width={width}
            height={height}
            style={{
                maxWidth: '100%',
                height: 'auto',
                // filter: src === lowQualitySrc ? 'blur(5px)' : 'none',
                transition: 'filter 0.3s ease-out'
            }}
        />
    );
};
